<template>
  <Banners
    :sticky-top="true"
    :narrow="true"
    :is-ultra="true"
  >
    <MyLoadsDesktopMainComponent></MyLoadsDesktopMainComponent>

    <dialog
      id="dialog"
      class="dialog-carrier-dashboard outline-none"
    >
      <CarrierPortalEldProviderModal></CarrierPortalEldProviderModal>
    </dialog>
  </Banners>
</template>

<script type="text/javascript">
import moment from 'moment';
import {
  Banners,
  CarrierPortalEldProviderModal,
  MyLoadsDesktopMainComponent,
} from '@/components';
import CONFIG from '@/config';
import rulesSyntax from '@/common/rulesSyntax.js';

export default {
  name: 'CarrierWelcomePage',
  components: {
    MyLoadsDesktopMainComponent,
    Banners,
    CarrierPortalEldProviderModal,
  },
  data() {
    return {
      rulesSyntax,
      preferredNameModalVisible: false,
      confirmCompanyEmailModalVisible: false,
      has_incomplete_eld: true,
    };
  },
  computed: {
    canViewMyLoads() {
      return (
        this.$store.getters['users/userIsADriver'] ||
        this.$store.state.users.currentUser?.scopes?.includes(
          'carrier_load_abilities'
        )
      );
    },
    displayName() {
      return this.currentUser?.preferred_name || this.currentUser?.first_name;
    },
    showHeroSection() {
      return (
        (!this.latest_carrier_eld_provider?.integration?.id ||
          this.hasInvalidEldCredentials ||
          this.hasUnverifiedEldCredentials) &&
        this.latest_carrier_eld_provider_has_loaded
      );
      // return this.latest_carrier_eld_provider?.id > 0 && this.latest_carrier_eld_provider_has_loaded;
    },
    hasInvalidEldCredentials() {
      return (
        (this.latest_carrier_eld_provider?.integration
          ?.eld_credentials_verified === false &&
          this.latest_carrier_eld_provider?.connect_channel
            ?.is_auto_eld_credentials) ||
        this.latest_carrier_eld_provider?.integration?.revoked_at !== null
      );
    },
    hasUnverifiedEldCredentials() {
      return (
        this.latest_carrier_eld_provider?.integration
          ?.eld_credentials_verified === null &&
        this.latest_carrier_eld_provider?.connect_channel
          ?.is_auto_eld_credentials
      );
    },
    hasValidEldCredentials() {
      return (
        this.latest_carrier_eld_provider?.integration
          ?.eld_credentials_verified &&
        this.latest_carrier_eld_provider?.connect_channel
          ?.is_auto_eld_credentials
      );
    },
    currentEldIntegration() {
      return this.$store.state.onboardingPacket?.current_eld_integration;
    },
    updateEld() {
      return this.$route?.query?.updateEld || false;
    },
    connectEld() {
      return this.$route?.query?.connectEld || false;
    },
    connections() {
      let conns = [...this.$store.state.brokers.connections];
      return conns.filter(
        (conn) => conn?.company_id !== 1 && conn?.status !== 'do_not_dispatch'
      );
    },
    loading() {
      return this.$store.state.loading.isLoading;
    },
    empty() {
      return this.$store.state.loading.isEmpty;
    },
    availableConnections() {
      const userConnections = this.connections;
      const allAvailableConnections =
        this.$store.state.brokers.availableConnections;

      const filteredConnections = allAvailableConnections?.filter(
        (connection) => {
          return !userConnections?.some(
            (userConnection) => userConnection?.company_id === connection?.id
          );
        }
      );

      return filteredConnections.length
        ? filteredConnections
        : allAvailableConnections;
    },
    currentUser() {
      return this.$store.state.users?.currentUser;
    },
    latest_carrier_eld_provider() {
      if (this.$store.state.onboardingPacket?.latest_carrier_eld_provider) {
        return this.$store.state.onboardingPacket?.latest_carrier_eld_provider;
      } else if (
        this.$store.state.carriers?.carrierData?.latest_carrier_eld_provider
      ) {
        return this.$store.state.carriers?.carrierData
          ?.latest_carrier_eld_provider;
      }
      return null;
    },
    latest_carrier_eld_provider_has_loaded() {
      return this.$store.state.onboardingPacket
        ?.latest_carrier_eld_provider_has_loaded;
    },
    linkable_broker() {
      return this.$store.state.users.featureFlags?.onboarding_linkable_brokers
        ?.enabled;
    },
    carrier_load_board_enabled() {
      return this.$store.state.users.currentUser?.scopes?.includes(
        'carrier_view_posted_loads'
      );
    },
    loads() {
      return this.$store.state.loads?.dispatch || [];
    },
    transit_loads_length() {
      return this.$store.state.loads?.transit?.length || 0;
    },
    completed_loads_length() {
      return this.$store.state.loads?.completed?.length || 0;
    },
    showConnectEldDialog() {
      return this.$store.state.myLoadsStore.showConnectEldDialog;
    },
  },
  watch: {
    showConnectEldDialog: {
      handler: function (val) {
        if (val) {
          this.handleConnectELDClick();
        }
      },
    },
    updateEld: {
      handler: function (val) {
        if (val) {
          this.handleConnectELDClick();
          this.$store.commit('integrations/setUpdateEld', true);
          this.$router.replace({ query: { updateEld: false } });
        }
      },
    },
    latest_carrier_eld_provider: {
      handler: function (val) {
        if (
          val &&
          val?.id > 0 &&
          this.$store.state.onboardingPacket?.current_eld_integration === null
        ) {
          this.$store.dispatch('onboardingPacket/getMostRecentEldIntegration');
        }
      },
    },
  },
  async created() {
    this.$store.commit('loading/loadingToggleOn', null, {
      root: true,
    });
    this.$store.commit('loading/emptyToggleOn', null, {
      root: true,
    });
    await this.$store.dispatch(
      'onboardingPacket/getLatestEldProvider',
      this.$store.state.users?.currentUser?.company?.carrier_id
    );
  },
  async mounted() {
    if (this.connectEld) {
      this.handleConnectELDClick();
    }
    if (this.updateEld) {
      this.handleConnectELDClick();
      this.$store.commit('integrations/setUpdateEld', true);
      this.removeUpdateEld();
    }
    // The homepage screen will never be used for mobile app users. If a mobile app user navigates to the homepage, they should be redirected back to the app.
    if (window.ReactNativeWebView?.postMessage) {
      console.log('window.ReactNativeWebView', window.ReactNativeWebView);
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'Navigation',
          screen: 'OnboardingScreen',
        })
      );
    }

    if (this.$route?.query?.message) {
      this.$toast.open({
        message: this.$route.query?.message?.replaceAll('+', ' '),
        type: 'success',
        duration: 5000,
        dismissible: true,
        position: 'top-right',
      });

      this.$router.replace({
        query: {
          ...this.$route.query,
          message: undefined,
        },
      });
    }
    this.removeRedirectAfterIDV();
  },
  methods: {
    removeRedirectAfterIDV() {
      localStorage?.removeItem('redirectAfterIDV');
    },
    handleBroadcastEvent(event) {
      console.log(event);
      if (event == 'approved') {
        this.preferredNameModalVisible = true;
      }
    },
    removeUpdateEld() {
      // eslint-disable-next-line
      this.$router.push({ name: this.$route.name }).catch((err) => {});
    },
    handleConnectELDClickUpdate() {
      this.$store.commit('integrations/setUpdateEld', true);
      this.handleConnectELDClick();
    },
    handleConnectELDClick() {
      const dialog = document.getElementById('dialog');
      dialog?.showModal();
    },
    redirectToHighwayLink(link) {
      if (process.env.ENV_URL?.includes('localhost')) {
        link = link.replace('https://staging.highway.com', process.env.ENV_URL);
      }
      window.open(link, '_blank');
    },
    formatDate(date) {
      return moment(date).format('M/D/YY');
    },
    getFilteredRules(rulesAssessment) {
      return Object.entries(rulesAssessment).filter(([key, value]) => {
        return (
          value !== null &&
          !['carrier_id', 'company_id', 'overall_result'].includes(key)
        );
      });
    },
    getFailedRules(rulesAssessment) {
      let filteredRules = this.getFilteredRules(rulesAssessment);
      // eslint-disable-next-line
      let failedRulesArray = filteredRules.filter(([key, value]) => {
        return value === 'fail';
      });
      return failedRulesArray.map((el) => el[0]);
    },
    getIncompleteRules(rulesAssessment) {
      let filteredRules = this.getFilteredRules(rulesAssessment);
      // eslint-disable-next-line
      let incompleteRulesArray = filteredRules.filter(([key, value]) => {
        return value === 'incomplete';
      });
      return incompleteRulesArray.map((el) => el[0]);
    },
    goToBrokerPortal(connection) {
      const { client_id, redirect_uri } = connection;
      let encodedURI = encodeURIComponent(redirect_uri);
      window.open(
        `${CONFIG.ENV_URL}${CONFIG.BASE_URL}oauth/authorizations?response_type=code&client_id=${client_id}&scope=onboarding&redirect_uri=${encodedURI}`,
        '_blank'
      );
      // window.location.href = `${CONFIG.ENV_URL}${CONFIG.BASE_URL}oauth/authorizations?response_type=code&state=1&client_id=${client_id}&scope=onboarding&redirect_uri=${encodedURI}`;
      // window.open(
      //   `https:${CONFIG.ENV_URL}${CONFIG.BASE_URL}oauth/authorizations?response_type=code&state=1&client_id=${client_id}&scope=onboarding&redirect_uri=${encodedURI}`,
      //   '_blank'
      // );
    },
    goToOnboardingPacketStatus(latest_onboarding_packet_id) {
      if (latest_onboarding_packet_id > 0) {
        window.open(
          process.env.ENV_URL +
            process.env.BASE_URL +
            'carrier/onboarding_packets/' +
            latest_onboarding_packet_id +
            '/status',
          '_blank'
        );
        // this.$router.push({
        //   name: "Carrier Onboarding Packet Status",
        //   params: {
        //     id: latest_onboarding_packet_id,
        //   },
        // });
      }
    },
    isAssessmentPass(text) {
      return ['pass', 'partial_pass'].includes(text);
    },
    handleLetsGo() {
      this.has_incomplete_eld = false;
    },
  },
};
</script>

<style scoped>
dialog {
  border-radius: 10px;
}

.dialog-carrier-dashboard {
  margin: 5vh auto;
}

@media (min-width: 640px) {
  .dialog-carrier-dashboard {
    margin: 7.5vh auto;
  }
}

dialog::backdrop {
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(7px);
}

.header-text {
  font-size: 26px;
}
.subheader-text {
  font-size: 18px;
}

.notice-text {
  @apply text-center text-body-color;
  font-size: 13px;
}

.fail-status {
  padding: 4px 8px;
  background: #fff0e3;
  border-radius: 30px;
  font-size: 10px;
  /* width: 34px; */
  height: 24px;
  @apply text-orange-600;
}

.pass-status {
  padding: 4px 8px;
  background: #ddf4e3;
  border-radius: 30px;
  font-size: 10px;
  /* width: 40px; */
  height: 24px;
  @apply text-green-600;
}

.incomplete-status {
  padding: 4px 8px;
  background: #d6d7da;
  border-radius: 30px;
  font-size: 10px;
  /* width: 74px; */
  height: 24px;
}

::marker {
  font-size: 14px;
  margin-right: 20px;
  @apply text-body-color;
}

ul li {
  list-style-type: disc;
  list-style-position: inside;
  @apply mb-2 ml-6 text-1md;
  /* padding: 10px 0 10px 20px; */
  text-indent: -1em;
}

.link-icon {
  position: relative;
  bottom: 1px;
}

.notice-text {
  @apply text-center text-gray-over-dark;
  font-size: 16px;
}

/* .portal-btn[disabled] > .tester {
  @apply text-light-gray group-hover:text-light-gray;
} */

@keyframes wifiCircle {
  /* 0%, 6.5% {
    r: 0.25;
  }
  7.5%, 15% {
    r: 0.5;
  }
  16%, 23.5% {
    r: 0.75;
  }
  24.5% {
    r: 1.01;
  }
  100% {
    r: 1.01;
  } */
  0%,
  3.25% {
    r: 0.25;
  }
  3.75%,
  7.5% {
    r: 0.5;
  }
  8%,
  11.75% {
    r: 0.75;
  }
  12.25% {
    r: 1.01;
  }
  100% {
    r: 1.01;
  }
}

#clip0 circle {
  animation: wifiCircle 5s infinite ease-in-out;
}

@keyframes wifiSVG {
  0%,
  25%,
  62.5%,
  100% {
    opacity: 1;
  }
  43.75%,
  81.25% {
    opacity: 0.5;
  }
}

#eld-wifi {
  animation: wifiSVG 5s infinite ease-in-out;
}

.hide-small {
  display: none;
}
@media (min-width: 360px) {
  .hide-small {
    display: initial;
  }
}
</style>
